import gql from 'graphql-tag';

export const GET_COUNTRIES = gql`
  query CountriesDictionary {
    dealSheets {
      result: countriesDictionary {
        error
        success
        list {
          label
          value
        }
      }
    }
  }
`;
